'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _all = require('react-prop-types/lib/all');

var _all2 = _interopRequireDefault(_all);

var _bootstrapUtils = require('./utils/bootstrapUtils');

var _createChainedFunction = require('./utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _SafeAnchor = require('./SafeAnchor');

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  function MenuItem(props) {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(MenuItem, [{
    key: 'handleClick',
    value: function handleClick(event) {
      if (!this.props.href || this.props.disabled) {
        event.preventDefault();
      }

      if (this.props.disabled) {
        return;
      }

      if (this.props.onSelect) {
        this.props.onSelect(this.props.eventKey, event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.divider) {
        return _react2.default.createElement('li', {
          role: 'separator',
          className: (0, _classnames2.default)('divider', this.props.className),
          style: this.props.style
        });
      }

      if (this.props.header) {
        var headerClass = (0, _bootstrapUtils.prefix)(this.props, 'header');

        return _react2.default.createElement(
          'li',
          {
            role: 'heading',
            className: (0, _classnames2.default)(headerClass, this.props.className),
            style: this.props.style
          },
          this.props.children
        );
      }

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['className', 'style', 'onClick']);

      delete props.onSelect;

      var classes = {
        disabled: this.props.disabled,
        active: this.props.active
      };

      if (this.props.menuType === 'navigation') {
        return _react2.default.createElement(
          'li',
          { role: 'presentation',
            className: (0, _classnames2.default)(this.props.className, "fe-navigation__sub-item"),
            style: style
          },
          _react2.default.createElement(_SafeAnchor2.default, _extends({}, props, {
            role: 'menuitem',
            tabIndex: '-1',
            className: 'fe-navigation__sub-link',
            onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
          }))
        );
      } else {
        return _react2.default.createElement(
          'li',
          { role: 'presentation',
            className: (0, _classnames2.default)(className, classes),
            style: style
          },
          _react2.default.createElement(_SafeAnchor2.default, _extends({}, props, {
            role: 'menuitem',
            tabIndex: '-1',
            onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
          }))
        );
      }
    }
  }]);

  return MenuItem;
}(_react2.default.Component);

MenuItem.propTypes = {

  /**
   * Highlight the menu item as active.
   */
  active: _propTypes2.default.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: _propTypes2.default.bool,

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: _propTypes2.default.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: _propTypes2.default.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: _propTypes2.default.string,

  /**
   * HTML `target` attribute corresponding to `a.target`.
   */
  target: _propTypes2.default.string,

  /**
   * HTML `title` attribute corresponding to `a.title`.
   */
  title: _propTypes2.default.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: _propTypes2.default.func,

  onKeyDown: _propTypes2.default.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: _propTypes2.default.func,

  /**
   * HTML `id` attribute.
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  menuType: _propTypes2.default.string
};

MenuItem.defaultProps = {
  divider: false,
  disabled: false,
  header: false,
  menuType: 'normal',
  bsRole: 'MenuItem'
};

exports.default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);